import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import config from "@config";
import moment from "moment";
import utilityFunctions from "@store/utilityFunctions";
import Select from "react-select";
import { MdHistory, MdFileDownload, MdErrorOutline, MdCheckCircle, MdDateRange, MdPublic } from "react-icons/md";
import "./TimeMachine.css";

const countryOptions = [
  { value: "", label: "All" },
  { value: "AU", label: "Australia" },
  { value: "NZ", label: "New Zealand" },
];
export default class TimeMachine extends Component {
  constructor(props) {
    super(props);

    const userInfo =
      localStorage.getItem("userInfo") || utilityFunctions.getCookie("userInfo");
    this.user = userInfo && JSON.parse(userInfo).user;

    const initialCountry = config.country;
    const initialBrandIds = (this.user?.brands || [])
      .filter((brand) => (initialCountry ? brand.country === initialCountry : true))
      .map((brand) => brand.id);

    this.state = {
      loading: false,
      msgText: "",
      fromDate: null,
      toDate: null,
      country: initialCountry,
      brandIds: initialBrandIds,
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.state.fromDate || !this.state.toDate) {
      this.setState({ msgText: "Warning: Date can not be empty" });
      return;
    }
    if (this.state.fromDate > this.state.toDate) {
      this.setState({ msgText: "Warning: From date can not be greater than to date" });
      return;
    }
    this.setState({ loading: true, msgText: "" });

    const fromDate = this.state.fromDate ? `from_date=${moment(this.state.fromDate).format("YYYY-MM-DD")}` : "";
    const toDate = this.state.toDate ? `${this.state.fromDate ? "&" : ""}to_date=${moment(this.state.toDate).format("YYYY-MM-DD")}` : "";
    const brandParam = this.state.brandIds?.length ? `brand=${this.state.brandIds.join(",")}&` : "";

    const url = `${config.backendServer}report/export_activity_ticket/?${brandParam}${fromDate}${toDate}`;

    utilityFunctions
      .protectedFetch(url, "GET", null, (res) => {
        return res; // Do everything in the 'then'
      })
      .then((res) => {
        if (res.ok) {
          res.blob().then((res) => {
            const blob = res;
            blob.name = "Time_Machine_" + moment(this.state.toDate).format("YYYY-MM-DD");
            utilityFunctions.downloadFileAutomatically(blob, res.type);
            this.setState({ msgText: "Success: Time Machine Report successfully created", loading: false });
            setTimeout(() => this.props.handleCloseModal(), 3000);
          });
        }
      })
      .catch((error) => {
        console.log("fail");
        this.setState({ loading: false, msgText: error?.message || String(error) || "Error: Something went wrong" });
      });
  };

  render() {
    const { loading, fromDate, toDate, msgText } = this.state;
    const isWarning = msgText?.includes("Warning");
    const isSuccess = msgText?.includes("Succes");

    return (
      <div className="card tm-card">
        {/* Header */}
        <div className="card-header">
          <MdHistory className="header-icon" />
          <h6>Time Machine Report</h6>
        </div>

        <div className="card-body">
          <div className="tm-section-label">
            <MdDateRange size={13} />
            Date Range
          </div>
          <div className="tm-date-group">
            <div className="tm-date-row">
              <div className="tm-date-col">
                <label htmlFor="fromDate">From Date</label>
                <DatePicker
                  id="fromDate"
                  className="form-control"
                  maxDate={toDate || moment().toDate()}
                  selected={fromDate}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="DD/MM/YYYY"
                  onChange={(val) => this.setState({ fromDate: val, msgText: "" })}
                />
              </div>
              <div className="tm-date-col">
                <label htmlFor="toDate">To Date</label>
                <DatePicker
                  id="toDate"
                  className="form-control"
                  maxDate={moment().toDate()}
                  minDate={fromDate || undefined}
                  selected={toDate}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="DD/MM/YYYY"
                  onChange={(val) => this.setState({ toDate: val, msgText: "" })}
                />
              </div>
            </div>

            {/* Inline message banner */}
            {msgText && (
              <div className={`tm-message-banner ${isWarning ? "tm-message-warning" : isSuccess ? "tm-message-success" : "tm-message-error"}`}>
                {isSuccess ? <MdCheckCircle size={15} /> : <MdErrorOutline size={15} />}
                {msgText.replace(/^(Warning|Succes|Error):\s*/, "")}
              </div>
            )}
          </div>

          {/* Country Section */}
          <div className="tm-section-label" style={{ marginTop: "16px" }}>
            <MdPublic size={13} />
            Country
          </div>
          <div className="tm-country-group">
            <label htmlFor="tm-country">Filter by country</label>
            <Select
              inputId="tm-country"
              classNamePrefix="react-select"
              value={countryOptions.find((option) => option.value === this.state.country)}
              options={countryOptions}
              onChange={(option) =>
                this.setState({
                  country: option?.value || "",
                  brandIds: (this.user?.brands || [])
                    .filter((brand) =>
                      option?.value ? brand.country === option?.value : true
                    )
                    .map((brand) => brand.id),
                })
              }
            />
          </div>
        </div>

        {/* Footer */}
        <div className="card-footer">
          <button
            type="button"
            className="btn btn-outline-secondary tm-btn-cancel"
            onClick={() => this.props.handleCloseModal()}
            disabled={loading}
          >
            Close
          </button>
          <button
            type="submit"
            className="btn tm-btn-export"
            onClick={this.handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="tm-spinner" />
                Exporting…
              </>
            ) : (
              <>
                <MdFileDownload size={16} />
                Export
              </>
            )}
          </button>
        </div>
      </div>
    );
  }
}
